var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationsColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.96 6.17C18.96 7.56 20.34 9.77 20.62 12.32",
    stroke: "url(#paint0_linear_6001_63)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49023 12.37C3.75023 9.83 5.11023 7.62 7.09023 6.22",
    stroke: "url(#paint1_linear_6001_63)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18994 20.94C9.34994 21.53 10.6699 21.86 12.0599 21.86C13.3999 21.86 14.6599 21.56 15.7899 21.01",
    stroke: "url(#paint2_linear_6001_63)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0598 7.7C13.5951 7.7 14.8398 6.45535 14.8398 4.92C14.8398 3.38465 13.5951 2.14 12.0598 2.14C10.5244 2.14 9.27979 3.38465 9.27979 4.92C9.27979 6.45535 10.5244 7.7 12.0598 7.7Z",
    stroke: "url(#paint3_linear_6001_63)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8298 19.92C6.36516 19.92 7.60981 18.6754 7.60981 17.14C7.60981 15.6046 6.36516 14.36 4.8298 14.36C3.29445 14.36 2.0498 15.6046 2.0498 17.14C2.0498 18.6754 3.29445 19.92 4.8298 19.92Z",
    stroke: "url(#paint4_linear_6001_63)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1701 19.92C20.7055 19.92 21.9501 18.6754 21.9501 17.14C21.9501 15.6046 20.7055 14.36 19.1701 14.36C17.6348 14.36 16.3901 15.6046 16.3901 17.14C16.3901 18.6754 17.6348 19.92 19.1701 19.92Z",
    stroke: "url(#paint5_linear_6001_63)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6001_63",
    x1: 16.9398,
    y1: 9.24502,
    x2: 20.6402,
    y2: 9.24502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6001_63",
    x1: 3.47037,
    y1: 9.29503,
    x2: 7.11011,
    y2: 9.29503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6001_63",
    x1: 8.14801,
    y1: 21.4,
    x2: 15.8319,
    y2: 21.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6001_63",
    x1: 9.24911,
    y1: 4.92002,
    x2: 14.8705,
    y2: 4.92002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6001_63",
    x1: 2.01913,
    y1: 17.14,
    x2: 7.6405,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6001_63",
    x1: 16.3595,
    y1: 17.14,
    x2: 21.9808,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8CC63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsColor);
export default __webpack_public_path__ + "static/media/Integrations_color.12eabd0accdd9fb415cf779265ffae41.svg";
export { ForwardRef as ReactComponent };